import categoriesView from './modules/_categoriesView';
import infoSlider from './sliders/infoSlider/infoSlider';
import productTilesSlider from './sliders/productTiles/productTilesSlider';
import filter from './modules/_filter';
import rangeSlider from './modules/_range-slider';

document.addEventListener('DOMContentLoaded', () => {
  window.productTilesSlider = productTilesSlider

  filter();
  rangeSlider();
  categoriesView();

  const infoSliders = Array.prototype.slice.call(document.querySelectorAll('.js-info-slider'));
  if (infoSliders.length) {
    infoSliders.forEach((el) => {
      infoSlider(el);
    });
  }


  const productTilesSliders = Array.prototype.slice.call(document.querySelectorAll('.js-products-tiles-slider-wrap'));
  if (productTilesSliders.length) {
    productTilesSliders.forEach((el) => {
      productTilesSlider(el);
    });
  }
});
